/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BankTransferService = {
  async saveBankTransferService(payload) {
    const url = `api/Save_BankTransfer`;
    return await ApiService.post(url, payload);
  },
  async getActiveAccountPeriod() {
    const getActiveAccountPeriod = {
      url: "api/JournalActiveAccountingPeriod",
      top: "1",
    };
    return await ApiService.oDataGet(getActiveAccountPeriod);
  },
};

export { BankTransferService };
